<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加机构</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-row>
                    <el-col :span="24" class="item">
                        <div class="label">机构logo</div>
                        <el-upload
                        class="upload-demo"
                            :action="uploadUrl"
                            list-type="picture-card"
                            :data='uploadData'
                            :show-file-list="false"
                            :on-success="handleImgSuccess"
                            style="width:100%;">
                            <img v-if="add_logo" :src="add_logo" fit='cover'  class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">机构名称</div>
                        <el-input v-model="add_name" placeholder="请输入机构名称"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">固话</div>
                        <el-input v-model="add_tel" placeholder="请输入固定电话"></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">联系人</div>
                        <el-input v-model="add_contacts" placeholder="请输入联系人"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">地址</div>
                        <el-input v-model="add_address" disabled placeholder="请选择详细地址" class="homeAddress">
                            <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">
                            选择
                            </el-button>
                        </el-input>
                        <!-- <el-input v-model="add_address" placeholder="请输入地址"></el-input> -->
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">是否连锁</div>
                        <el-radio v-model="add_isChain" label="0">否</el-radio>
                        <el-radio v-model="add_isChain" label="1">是</el-radio>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">连锁类型</div>
                        <el-select v-model="add_chainType"  @change="chainTypesChange" style="width: 100%">
                            <el-option
                                    v-for="item in chainTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="item">
                        <div class="label">机构简介</div>
                        <el-input v-model="add_description" type="textarea" :rows="3" placeholder="请输入机构简介"></el-input>
                    </el-col>
                </el-row>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>
        <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:colseMap="baiduMapShow = false" v-on:setMap="setMap"></BaiduMap>
    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import BaiduMap from "./BaiduMap";
    export default {
        name: 'Add',
        props: [],
        data() {
            return {

                loading: false,
                baiduMapShow:false,
                add_name:'',
                add_tel:'',
                add_contacts:'',
                add_address:'',
                add_isChain:'0',
                add_lon:'',
                add_lat:'',
                add_logo:'',
                add_description:'',
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                chainTypes: [{
                    value: 'parent',
                    label: '总机构'
                }, {
                    value: 'middle',
                    label: '中间机构'
                }, {
                    value: 'son',
                    label: '分机构'
                }],
                add_chainType: 'parent',

            }
        },
        components:{
            BaiduMap
        },
        methods: {
            init(){
                console.log("Add init");

                this.add_name = '';
                this.add_tel = '';
                this.add_contacts = '';
                this.add_address = '';

            },
            handleImgSuccess(res) {
                this.add_logo = this.$imgUrl+res.data.path;
            },
            openBaiduMap() {
                this.$refs.baiduMap.init();
                this.baiduMapShow = true;
            },
            setMap(info) {
                this.add_address = info.addressInfo
                this.add_lon = info.lng
                this.add_lat = info.lat
                this.baiduMapShow = false
            },
            closeSelf() {
                this.$emit("closeAdd");
            },

            chainTypesChange:function(selVal){
                this.add_chainType = selVal;
            },

            confirm(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                if(!this.add_logo){
                    this.loading = false;
                    return;
                }
                if(!this.add_name){
                    this.loading = false;
                    return;
                }
                if(!this.add_tel){
                    this.loading = false;
                    return;
                }
                if(!this.add_contacts){
                    this.loading = false;
                    return;
                }
                if(!this.add_address){
                    this.loading = false;
                    return;
                }
                if(!this.add_lon){
                    this.loading = false;
                    return;
                }
                if(!this.add_lat){
                    this.loading = false;
                    return;
                }
                if(!this.add_description){
                    this.loading = false;
                    return;
                }
                

                if(this.add_isChain == '0'){
                    this.add_chainType = 'parent';
                }

                this.add_logo=this.add_logo.replace(this.$imgUrl,'')
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Institution/Add',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name: this.add_name,
                        tel:this.add_tel,
                        contacts:this.add_contacts,
                        address:this.add_address,
                        isChain:this.add_isChain,
                        chainType:this.add_chainType,
                        lon:this.add_lon,
                        lat:this.add_lat,
                        description:this.add_description,
                        logo:this.add_logo,

                    }
                }).then( (response)=> {
                    console.log(response.data);
                    this.loading = false;

                    if(response.data.error == 0){
                        this.$emit("closeAdd");
                        this.$emit("getList");
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },




        }
    }
</script>


<style lang="scss" scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
        box-shadow: 2px 2px 20px 1px;
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 750px;
        /deep/ .el-input.is-disabled .el-input__inner {
            background-color: #fff;
            border-color: #DCDFE6;
            color: #606266;
            cursor: not-allowed;
        }
    }
    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y:auto;
        height: 350px;
        .avatar-uploader{ 
            .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
        }
        .avatar {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            display: block;
        }
        /deep/ .el-upload--picture-card{
            width: 100px;
            height: 100px;
            line-height: 100px;
        }
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
